/* Inkfold header behavior */
(function () {
  const header = document.querySelector("[data-vs-header]");
  if (!header) return;

  /* ---------- Sticky behavior ---------- */
  const STUCK_AT = 80;
  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      header.classList.toggle("is-stuck", window.scrollY > STUCK_AT);
      ticking = false;
    });
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- Mobile drawer ---------- */
  const drawer = document.querySelector("[data-vs-drawer]");
  const trigger = document.querySelector("[data-vs-drawer-trigger]");
  if (!drawer || !trigger) return;

  const panel = drawer.querySelector(".vs-mobile-drawer__panel");
  const closeEls = drawer.querySelectorAll("[data-vs-drawer-close]");

  let lastFocus = null;

  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add("is-open"));
    document.documentElement.classList.add("vs-drawer-open");
    document.body.classList.add("vs-drawer-open");
    trigger.setAttribute("aria-expanded", "true");
    panel.focus();
    document.addEventListener("keydown", onKeydown);
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    document.documentElement.classList.remove("vs-drawer-open");
    document.body.classList.remove("vs-drawer-open");
    trigger.setAttribute("aria-expanded", "false");
    document.removeEventListener("keydown", onKeydown);
    /* Wait for transition to finish before hiding from a11y tree. */
    setTimeout(() => { drawer.hidden = true; }, 300);
    if (lastFocus && typeof lastFocus.focus === "function") {
      lastFocus.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === "Escape") closeDrawer();
  }

  trigger.addEventListener("click", openDrawer);
  closeEls.forEach((el) => el.addEventListener("click", closeDrawer));
})();
